/** @jsx h */
import { h, Component } from 'preact'
import LinkIcon from '../icons/Link'

export default class JourneyOrganization extends Component {
  render () {
    const { exitButtonLabel, exitLink } = this.props

    const validExitLink =
      exitLink.substring(0, 4) === 'http' ? exitLink : `http://${exitLink}`

    return (
      <div class='JourneyOrganization'>
        <div class='JourneyOrganization-links'>
          <a
            class='Action Action--whiteHoverGrey JourneyOrganization-link'
            id='JourneyExit-link'
            href={validExitLink}
            target='_blank'
            rel='noopener noreferrer'
          >
            <LinkIcon />
            {exitButtonLabel}
          </a>
        </div>
      </div>
    )
  }
}

JourneyOrganization.defaultProps = {
  exitButtonLabel: 'View profile'
}
